import urls from "global/constants/UrlConstants";
import { getCallParams, makeCall } from "utils/service";

export const getReportEnvelopesMetrics = async (payload: any) => {
  try {
    const url = urls.GET_REPORT_ENVELOPES;
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getTotalDocumentProgressMetrics = async (payload: any) => {
  try {
    const url = urls.GET_REPORT_COUNTS_METRICS;
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error) {
    throw error;
  }
};
